<template>
  <div class="iv-message">
    <div class="iv-main-width iv-p-t-20">
      <Tab ref="tab" :navList="navList" @on-click="tabClick" v-if="show">
        <template v-slot:extra >
          <p class="iv-p" style="cursor:pointer" @click="gohistorydone">查看历史归档已办</p>
        </template>
      </Tab>
      <component @forceRender="forceRenderFn" ref="learnContent" :is="learnContent" :name="learnContent" @onloaded="onloaded"></component>
    </div>
  </div>
</template>

<script>
import Tab from '@/components/tab'
import alreadyDone from './already-done'
import remainDone from './remain-done'

export default {
  data () {
    return {
      name: '',
      learnContent: 'remainDone',
      selectionChange: [],
      show: false,
      tableData: [],
      handleCount: 0,
      showCount: 0
    }
  },
  created () {
    this.getTodoCount()
  },
  methods: {
    onloaded () {},
    forceRenderFn(data){
      // this.$refs.tab.setTabName(1,  `已办（${data.showCount}条已办）`)
      if(data.handleCount == 0) {
        this.$refs.tab.setTabName(0,  `待办`)
      } else {
        this.$refs.tab.setTabName(0,  `待办（${data.handleCount}条未办）`)
      }
    },
    getTodoCount () {
      this.$ajax({
        url: '/api-uum/todo/getTodoCount',
        method: 'get',
      }).then((data) => {
        this.handleCount = data.data.data.handleCount
        this.showCount = data.data.data.showCount
        this.show = true
        this.initTabs()
      })
    },
    gohistorydone () {
      let newUrl = this.$router.resolve({
        name: 'historyDone'
      })
      window.open(newUrl.href, "_blank")
    },
    onSelectionChange (list) {
      this.selectionChange = list
    },
    tabClick (name) {
      if (name === 'unread') {
        this.learnContent = 'remainDone'
      } else {
        this.learnContent = 'alreadyDone'
      }
    },
    initTabs () {
      this.navList = [{
        label: this.handleCount?`待办（${this.handleCount}条未办）`:`待办`,
        name: 'unread'
      }, {
        label: `已办`,
        name: 'all'
      }]
    }
  },
  components: {
    Tab,
    remainDone,
    alreadyDone
  }
}
</script>

<style lang="scss" scoped>
.iv-message {
  // height: 100%;
  background-color: #fff;
  /deep/ .iv-drag-table {
    .ivu-table-row {
      .ivu-table-cell {
        font-size: 16px;
        color: rgba($color: #000000, $alpha: 0.65);
      }
    }
  }
}
.iv-p {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 400;
}
</style>
